console.warn('cleanup: move to component');
import { ILocation } from "@vierkant-software/types__api";

export function formatAddress(value: ILocation, short = false): string {
    if (short)
        return shortFormat(value);
    return longFormat(value);
}

function longFormat(value: ILocation){
    if (!value) return '';

    let result = '';
    if (value.street)
        result += value.street + "\n";
    if (value.houseNumber)
        result = result.trim() + " " + value.houseNumber + "\n";
    if (value.postcode)
        result = result.trim() + "\n" + value.postcode;
    if (value.city)
        result = result.trim() + " " + value.city + "\n";
    if (value.country)
        result = result.trim() + "\n" + value.country;
    return result.trim();
}

function shortFormat(value: ILocation): string {
    const {street, houseNumber, postcode, city} = value;
    let result = '';
    result = `${street ?? ''} ${houseNumber ?? ''}, ${postcode ?? ''} ${city ?? ''}`;
    // replace double whitespace, leading comma or space before comma.
    return result.trim().replace(/^,|\s{2}/g, '').replace(/\s,/, ',').trim();
}
